import React, { createContext, useEffect, useContext, useRef } from "react";
import axios from "axios";
import { setCookie, getCookie, removeCookie } from "../common/cookieHelper";
import { useNavigate } from "react-router-dom";

export const accessTokenCookieKey = "__RESEARCHFLOW_ACCESS_TOKEN";
export const autoSigninCookieKey = "__RESEARCHFLOW_AUTO_SIGNIN";

export var ApiContext = createContext();

export function ApiContextProvider({ children }) {
  const navigate = useNavigate();
  const instance = useRef(
    axios.create({
      baseURL: process.env.REACT_APP_API_ORIGIN,
      headers: {
        "Content-Type": "application/json",
      },
      timeout: 30000,
    })
  );
  var isInit = useRef(false);

  useEffect(() => {
    // init()
  }, []);

  const apiClient = () => {
    if (isInit.current) return instance.current;

    instance.current.interceptors.request.use(
      (config) => {
        const accessToken = getAccessToken();
        if (accessToken && accessToken !== "undefined") {
          config.headers["Authorization"] = `Bearer ${accessToken}`;
        }
        return config;
      },
      (error) => {
        Promise.reject(error);
      }
    );

    isInit.current = true;
    return instance.current;
  };

  const request = async (url, { method = "get", params = {} } = {}) => {
    const inst = apiClient();
    try {
      const response = await inst({
        url,
        method,
        [method.toLowerCase() === "get" ? "params" : "data"]: params,
      });
      print(
        method.toUpperCase(),
        `${response.config.baseURL}${url}`,
        JSON.stringify(params),
        response.data
      );

      return { status: response.status, data: response.data };
    } catch (error) {
      const { status, data } = error?.response ?? {};
      print(
        `ERROR ${method.toUpperCase()}`,
        `${error.config.baseURL}${url}`,
        JSON.stringify(params),
        error.response ?? error
      );
      return { status, data, error };
    }
  };

  const setAccessToken = (token) => {
    setCookie(accessTokenCookieKey, token);
  };

  const getAccessToken = () => {
    const token = getCookie(accessTokenCookieKey);
    return token;
  };

  const removeAuthToken = () => {
    removeCookie(accessTokenCookieKey);
  };

  const setAutoSignin = (autoSignin) => {
    setCookie(autoSigninCookieKey, autoSignin ? "true" : "false");
  };

  const getAutoSignin = () => {
    return getCookie(autoSigninCookieKey) == "true";
  };

  const print = (tag, url, param, data) => {
    var printParam = JSON.parse(param);
    if (printParam.action === "uploadProfileImage") {
      printParam.file = "image";
    }
    var printData = JSON.parse(JSON.stringify(data));
    if (printParam.action === "downloadQuestionImage") {
      if (!!printData.data) printData.data["image"] = "image";
    }

    console.log(`===========================================
${tag} : ${url}
param : ${JSON.stringify(printParam)}
-------------------------------------------
recv : ${JSON.stringify(printData)}}
===========================================`);
  };

  const networkError = async (result, alert) => {
    if (result?.status === 401) {
      await showAlert("세션이 종료되었습니다.\n다시 로그인 해주세요.", alert);
      navigate("/signin");
    } else if (result?.status === 403) {
      await showAlert(
        result?.data?.msg ??
          result?.data?.detail ??
          "접근 권한이 없습니다.\n다시 로그인 해주세요.",
        alert
      );
      navigate("/signin");
    } else if (!!result?.data?.msg || !!result?.data?.detail) {
      await showAlert(result?.data?.msg ?? result?.data?.detail, alert);
    } else if (!!result?.error?.message || !!result?.error) {
      const errorMessage = result?.error?.message ?? result?.error;
      if (errorMessage.includes("timeout")) {
        await showAlert("시간이 초과되었습니다.\n다시 시도해 주세요.", alert);
      } else {
        await showAlert(errorMessage, alert);
      }
    } else {
      await showAlert(result?.data?.msg ?? "error", alert);
    }
  };

  return (
    <ApiContext.Provider
      value={{
        getAccessToken,
        setAccessToken,
        removeAuthToken,
        setAutoSignin,
        getAutoSignin,
        networkError,
        request,
      }}
    >
      {children}
    </ApiContext.Provider>
  );
}

const showAlert = async (message, alert) => {
  if (!!alert) {
    return alert(message, { title: "오류" });
  } else {
    window.alert(message);
  }
};

export function useApi() {
  return useContext(ApiContext);
}
